import { useTranslation } from 'react-i18next';

import { StyleProps, Text, VStack } from '@bonusly/design-system';

export function BizyPeopleEmptyState(props: StyleProps) {
	const { t } = useTranslation('admin_bizy');

	return (
		<VStack align="stretch" spacing={1} borderWidth="1px" borderColor="border.soft" borderRadius="md" px={3} py={2} {...props}>
			<Text size="sm" fontWeight="semibold" color="text.softer">
				{t('menu.noMomentsTitle')}
			</Text>
			<Text size="sm" color="text.softest">
				{t('menu.noMomentsBody')}
			</Text>
		</VStack>
	);
}
